import { mapEnumToOptions } from '@abp/ng.core';

export enum ConfigurationState {
  Inactive = 0,
  Active = 1,
}

export const configurationStateOptions = mapEnumToOptions(ConfigurationState);
